import { applyServiceWorkerUpdate } from '@/registerServiceWorker.js'

export default {
  data() {
    return { showRefreshApp: false }
  },

  created() {
    window.addEventListener('v4lUpdateAvailable', this.handleAppUpdate)
  },

  beforeUnmount() {
    window.removeEventListener('v4lUpdateAvailable', this.handleAppUpdate)
  },

  methods: {
    handleAppUpdate() {
      this.showRefreshApp = true
    },

    dismissAppUpdate() {
      this.showRefreshApp = false
    },

    async refreshApp() {
      this.showRefreshApp = false
      await applyServiceWorkerUpdate()
    }
  }
}
